import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'taxonomyFieldLoadingAriaLabel'
  | 'taxonomyFieldMultiSelectPlaceholderMessage'
  | 'taxonomyFieldSingleSelectPlaceholderMessage';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  taxonomyFieldLoadingAriaLabel: {
    id: 'boxFileRequest.taxonomyField.loadingAriaLabel',
    description: 'Aria label for loading indicator in taxonomy field',
    defaultMessage: 'loading',
  },
  taxonomyFieldMultiSelectPlaceholderMessage: {
    id: 'boxFileRequest.taxonomyField.multiSelectPlaceholderMessage',
    description: 'Placeholder for multi select taxonomy field',
    defaultMessage: 'Select options',
  },
  taxonomyFieldSingleSelectPlaceholderMessage: {
    id: 'boxFileRequest.taxonomyField.singleSelectPlaceholderMessage',
    description: 'Placeholder for single select taxonomy field',
    defaultMessage: 'Select an option',
  },
});

export default messages;
